export interface Whitelist {
  id: BetaFeature;
  unblockerType: UnblockerType;
  unblocker: string;
  contentId: string;
  usersWhitelist: string[];
  unenrollCooldownMinutes: string;
  dismissCooldownMinutes: string;
  maybeLaterCooldownMinutes: string;
}

export enum UnblockerType {
  TOGGLE = "toggle",
  COOKIE = "cookie"
}

export enum BetaFeature {
  PROGRAM_PAGE = "programPage",
  MY_STABLE = "myStable"
}

export enum BetaFeatureStatus {
  UNENROLL = "unenroll",
  DISMISS = "dismiss",
  ENROLL = "enroll",
  WELCOMED = "welcomed"
}

export enum DismissOrigin {
  OVERLAY = "overlay",
  LATER = "later",
  CROSS = "cross"
}
